
// Definición de defaults

export const defaultTipoCalificacion: TipoCalificacionProps = {
    idTipoCalificacion:  0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface TipoCalificacionProps{
    idTipoCalificacion:  number;
    descripcion:    string;
    activo:         boolean;
}
